module.exports = __webpack_public_path__ + "img/php.87ef8a75.svg";